import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'
import { RouteComponentProps } from 'react-router-dom'

export interface InputProps extends RouteComponentProps<any> {}

export type Variables = {
  amount: number
  artnr: string
  clippingAmount?: number
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const POSITION_ALTERNATIVES_QUERY = gql`
  query getPositionAlternatives($amount: Float!, $artnr: String!, $clippingAmount: Float) {
    getPositionAlternatives(amount: $amount, artnr: $artnr, clippingAmount: $clippingAmount) {
      articleNumber
      product
      unitPrice
    }
  }
`

const withPositionAlternativesDataQuery = graphql<InputProps, Response, Variables, ChildProps>(
  POSITION_ALTERNATIVES_QUERY,
  {
    name: 'positionAlternativesData',
  },
)

export default withPositionAlternativesDataQuery
